import React, { Component } from 'react';
import Sidenavigation from '../layouts/Sidenavigation';
import Topnavigation from '../layouts/Topnavigation';
import Breadcrumb from '../sections/Orders/Breadcrumb';
import Favorder from '../sections/Orders/Favorder';
import FeedbackTable from '../sections/Orders/FeedbackTable';
import Quickbar from '../layouts/Quickbar';

class Feedback extends Component {
    render() {
        return (
            <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
                <Sidenavigation />
                <main className="body-content">
                    <Topnavigation />
                    <div className="ms-content-wrapper">
                        <div className="row">
                            <div className="col-md-12">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb pl-0">
                                        <li className="breadcrumb-item"><a href="/"><i className="material-icons">home</i> Home</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">Feedback Report</li>
                                    </ol>
                                </nav>
                                <FeedbackTable/>
                            </div>
                        </div>
                    </div>
                </main>
                <Quickbar />
            </div>
        );
    }
}

export default Feedback;